import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';
import type { ComplianceVerdict } from '../../types/scanner';

interface VerdictBannerProps {
  verdict: ComplianceVerdict;
  score: number;
}

export const VerdictBanner: React.FC<VerdictBannerProps> = ({ verdict, score }) => {
  const config = {
    PASS: {
      icon: CheckCircle,
      bg: '#dcfce7',
      border: 'var(--color-success)',
      text: '#166534',
      title: 'Website Passed Compliance Checks',
      summary: `Your website scored ${score}/100 and is ready for Google Ads.`,
    },
    WARN: {
      icon: AlertTriangle,
      bg: '#fef9c3',
      border: '#eab308',
      text: '#854d0e',
      title: 'Website Has Compliance Warnings',
      summary: `Your website scored ${score}/100. Review warnings before publishing.`,
    },
    FAIL: {
      icon: XCircle,
      bg: '#fee2e2',
      border: 'var(--color-error)',
      text: '#991b1b',
      title: 'Website Failed Compliance Checks',
      summary: `Your website scored ${score}/100. Critical issues must be fixed.`,
    },
  };

  const { icon: Icon, bg, border, text, title, summary } = config[verdict];

  return (
    <div style={{
      backgroundColor: bg,
      border: `3px solid ${border}`,
      padding: 'var(--space-4)',
      display: 'flex',
      alignItems: 'flex-start',
      gap: 'var(--space-3)',
    }}>
      <Icon size={24} style={{ color: border, flexShrink: 0, marginTop: 2 }} />
      <div style={{ flex: 1 }}>
        <h3 style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 700,
          color: text,
          margin: 0,
          textTransform: 'uppercase',
          letterSpacing: '0.025em',
        }}>
          {title}
        </h3>
        <p style={{
          fontSize: 'var(--text-sm)',
          color: text,
          margin: 'var(--space-2) 0 0',
        }}>
          {summary}
        </p>
      </div>
      <span style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 700,
        fontSize: 'var(--text-2xl)',
        color: text,
      }}>
        {score}%
      </span>
    </div>
  );
};

export default VerdictBanner;
